export const ElementById = (id: string): HTMLElement | null => {
  return document.getElementById(id)
}
